import { apolloClient, CREATE_REFERRED_TRAVELER_MUTATION } from '~/common/apollo'
import { toFormErrors } from '~/common/helpers'
import { action, computed, observable, store } from '~/common/mobx.decorator'
import { appStore, authStore, masterStore, notifyStore } from '~/stores'

@store()
class CareReferralStore {
	@observable success = false
	@computed
	get referredRelationshipsOptions() {
		return masterStore.referredRelationships
	}

	@computed
	get disciplineOptions() {
		return masterStore.disciplines
	}

	@action
	onSubmit = async (values, { setErrors, resetForm }, jobItem, setOpen) => {
		const deviceId = await window.host.getId()
		if (!!jobItem) {
			const url = await window.host.getDynamicJobLink(jobItem, authStore.id, appStore.meta_domain, appStore.store_ios_url, appStore.store_android_url)
			const referralUrl = await url.split('/').pop()

			values = authStore.isAnonymous
				? await {
						...values,
						relationship: values?.relationship === '' ? null : values?.relationship,
						deviceId,
						referralPath: referralUrl,
						jobId: jobItem?.id,
				  }
				: await {
						...values,
						jobId: jobItem?.id,
						referralPath: referralUrl,
						relationship: values?.relationship === '' ? null : values?.relationship,
				  }
		} else {
			const valuesParams = authStore.isAnonymous
				? {
						...values,
						relationship: values?.relationship === '' ? null : await values?.relationship,
						deviceId,
				  }
				: {
						...values,
						relationship: values?.relationship === '' ? null : await values?.relationship,
				  }
			values = valuesParams
		}

		try {
			await apolloClient.mutate({ mutation: CREATE_REFERRED_TRAVELER_MUTATION, variables: values })
			// notifyStore.success('$MESSAGES.REFERRING_TRAVELER')
			await resetForm()
			await setOpen(false)
			if (!jobItem) {
				if (authStore.id) {
					this.success = true
				} else {
					notifyStore.success('$MESSAGES.SUCCESSFUL')
				}
			} else {
				notifyStore.success('$MESSAGES.SUCCESSFUL')
			}
		} catch (error) {
			const errors = toFormErrors(error)
			setErrors(toFormErrors(error))

			if (errors.__ERROR) {
				notifyStore.error(errors.__ERROR)
			}
		}
	}

	@action
	toggleSuccess = async (value) => {
		this.success = value
	}
}

export const careReferralStore = new CareReferralStore()
